module.exports = __webpack_public_path__ + "img/red-circle.6b9f5269.png";